import { useEffect, useRef, useState } from 'react';

export function useCountdown(initialSeconds: number, enabled: boolean, onComplete?: () => void) {
  const [countdown, setCountdown] = useState(initialSeconds);
  const onCompleteRef = useRef(onComplete);
  const prevEnabledRef = useRef(enabled);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    if (enabled && !prevEnabledRef.current) {
      setCountdown(initialSeconds);
    }
    prevEnabledRef.current = enabled;
  }, [enabled, initialSeconds]);

  useEffect(() => {
    if (!enabled) return;

    if (countdown <= 0) {
      return;
    }

    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          onCompleteRef.current?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [countdown, enabled]);

  return countdown;
}
